'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var d = Object.getOwnPropertySymbols(e);
        for(o = 0; o < d.length; o++)t = d[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, d = Object.keys(e);
    for(o = 0; o < d.length; o++)t = d[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const Card = renderWithRef('Card', null, (t, o)=>{
    let { bordered: n = false, evenHeight: d = false, fullBleed: a = false, skin: i, children: l } = t, s = _object_without_properties(t, [
        "bordered",
        "evenHeight",
        "fullBleed",
        "skin",
        "children"
    ]), c = new Set([
        'swan-card'
    ]);
    return 'link' === i && c.add('swan-card-skin-link'), n && c.add('swan-card-bordered'), d && c.add('swan-card-even-height'), a && c.add('swan-card-full-bleed'), jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: c,
        props: s,
        children: l
    });
});

export { Card };
